module.exports = __webpack_public_path__ + "images/a7b8f90f81e16183dd8d0d1582bbce84-02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/02.jpg
// module id = ./src/assets/images/slides/home/02.jpg
// module chunks = 0